import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), ___EmotionJSX("line", {
  x1: "12",
  y1: "8",
  x2: "12",
  y2: "16"
}), ___EmotionJSX("line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12"
}));
export default SVG;